import { apiAxios } from "./apiConfig";

/* ================= TYPES ================= */

export interface AdminRole {
  id: string;
  name: string;
}

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string | null;
  updatedBy: string | null;
  role: AdminRole; // optional for create response
  creator?: any;
  updater?: any;
}

/* ================= ADMIN LIST ================= */

export interface AdminListResponse {
  status: boolean;
  data: AdminUser[];
}

export const getAdminList = async (): Promise<AdminListResponse> => {
  const response = await apiAxios.get("/admin/list");
  return response.data;
};

/* ================= ROLE LIST ================= */

export interface Role {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface RoleListResponse {
  status: boolean;
  data: Role[];
}

export const getRoleList = async (): Promise<RoleListResponse> => {
  const response = await apiAxios.get("/roles/list");
  return response.data;
};

/* ================= CREATE ADMIN ================= */

export interface CreateAdminPayload {
  roleId: string;
  name: string;
  email: string;
  password: string;
  isActive: boolean;
}

export interface CreateAdminResponse {
  status: boolean;
  data: AdminUser;
}

export const createAdmin = async (
  payload: CreateAdminPayload,
): Promise<CreateAdminResponse> => {
  const response = await apiAxios.post("/admin/create", payload);
  return response.data;
};

/* ================= UPDATE ADMIN ================= */

export interface UpdateAdminPayload {
  id: string;
  roleId: string;
  name: string;
  email: string;
  isActive: boolean;
}

export interface UpdateAdminResponse {
  status: boolean;
  data: string; // "Details updated succesful."
}

export const updateAdmin = async (
  payload: UpdateAdminPayload,
): Promise<UpdateAdminResponse> => {
  const { id, ...body } = payload;

  const response = await apiAxios.put(`/admin/${id}`, body);
  return response.data;
};

/* ================= RESET ADMIN PASSWORD ================= */

export interface ResetAdminPasswordPayload {
  id: string;
  password: string;
}

export interface ResetAdminPasswordResponse {
  status: boolean;
  data: string;
}

export const resetAdminPassword = async (
  payload: ResetAdminPasswordPayload,
): Promise<ResetAdminPasswordResponse> => {
  const { id, password } = payload;

  const response = await apiAxios.put(`/admin/${id}`, { password });
  return response.data;
};
